module.exports = __webpack_public_path__ + "media/components/lesson2/statics/serverConnection-afaddee308f5d0153cf64851db185741.png";